<script lang="ts">
  import { nrkStar, nrkStarActive } from '@nrk/core-icons';
  import { onMount } from 'svelte';
  import { get } from 'svelte/store';
  import {
    addFavourite,
    checkFavourite,
    favouriteStore,
    removeFavourite,
  } from '../api/favourite';
  import { i18n } from '../util/i18n/i18n';
  import { trackEvent } from '../util/snowplow';

  export let sourceMedium: 'tv' | 'radio';
  export let favouriteContentType: 'series' | 'programs' | 'podcast';
  export let contentId: string;

  onMount(async () => {
    const favouriteId = await checkFavourite(
      sourceMedium,
      favouriteContentType,
      contentId
    );
    if (favouriteId !== undefined) {
      favouriteStore.storeFavouriteId(contentId, favouriteId);
    }
  });

  let changingFavourite = false;
  let recentlyChanged = false;
  let timeoutRef: number;
  const toggleFavourite = async () => {
    changingFavourite = true;
    window.clearTimeout(timeoutRef);
    if (!isFavourite) {
      trackEvent({ action: 'click:add-favourite', label: contentId });

      const favouriteId = await addFavourite(
        sourceMedium,
        favouriteContentType,
        contentId
      );
      if (favouriteId !== undefined) {
        favouriteStore.storeFavouriteId(contentId, favouriteId);
      }
    } else {
      trackEvent({ action: 'click:remove-favourite', label: contentId });

      const favouriteId = get(favouriteStore)[contentId];
      if (favouriteId != null) {
        await removeFavourite(sourceMedium, favouriteId);
        favouriteStore.clearFavouriteId(contentId);
      }
    }
    recentlyChanged = true;
    timeoutRef = window.setTimeout(() => {
      recentlyChanged = false;
    }, 1000);
    changingFavourite = false;
  };

  $: checkedFavourite = $favouriteStore[contentId] !== undefined;
  $: isFavourite = $favouriteStore[contentId] !== null;
  $: content = isFavourite ? nrkStarActive : nrkStar;
</script>

{#if checkedFavourite}
  <button on:click={toggleFavourite} disabled={changingFavourite}>
    <div
      class="icon"
      class:switch={recentlyChanged}
      class:spin={changingFavourite}
    >
      <!-- eslint-disable-next-line svelte/no-at-html-tags -->
      {@html content}
    </div>
    {i18n(
      sourceMedium === 'tv'
        ? 'promo.add-in-my-content'
        : 'promo.follow-in-radio',
      { values: { isFavourite } }
    )}
  </button>
{/if}

<style>
  button {
    border-radius: 3px;
    background-color: #0c366c;
    width: 100%;
    text-align: left;
    display: flex;
    align-items: center;
    text-transform: unset;
  }

  button:active {
    transform: unset;
    animation: unset;
  }

  .icon {
    margin-right: 0.5rem;
    height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @keyframes switch {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(0);
    }

    100% {
      transform: scale(1);
    }
  }
  .switch {
    animation: switch 0.3s ease-in-out;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .spin {
    animation: spin 0.3s linear infinite;
  }
</style>
